import React, { useState } from "react";
import "./Add_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../features/admin/masters/faq/Slice";
import { IDS } from "../../../../../../../utils/IDS";

function Add_offcanvas({
  setShow,
  setSuccess,
  setErr,
  setShowError,
  defaultValues,
  showError,
  show,
  handleClose,
  setShowRejectModal,
}) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });
  const dispatch = useDispatch();

  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("question", data?.question || "");
      sendData.append("answer", data?.answer || "");

      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setModalsuccessShow(true);
        reset();
        setShow(false);
        setSuccess(true);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);

      setErr(true);
      console.error(error);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label> question</Form.Label>
                    <Form.Control
                      type="text"
                      title="question"
                      placeholder="question"
                      className={classNames("", {
                        "is-invalid": errors?.question,
                      })}
                      {...register("question", {
                        required: "question is required",
                        maxLength: {
                          value: 100,
                          message: "question cannot exceed 100 characters",
                        },
                      })}
                    />
                    {errors.question && (
                      <span className="text-danger">
                        {errors.question.message}
                      </span>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label> answers</Form.Label>
                    <Form.Control
                      type="text"
                      title="answer"
                      placeholder="answer"
                      className={classNames("", {
                        "is-invalid": errors?.description,
                      })}
                      {...register("answer", {
                        required: "answer is required",
                        maxLength: {
                          value: 100,
                          message: "title cannot exceed 100 characters",
                        },
                      })}
                    />
                    {errors.answer && (
                      <span className="text-danger">
                        {errors.answer.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
